import { render } from "./TheSettingsModal.vue?vue&type=template&id=6d5e6524"
import script from "./TheSettingsModal.vue?vue&type=script&lang=js"
export * from "./TheSettingsModal.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./TheSettingsModal.vue?vue&type=style&index=0&id=6d5e6524&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script